<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        Client Relationship Manager
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  layout: 'dashboard',
  data: () => ({ test: new Set() })
}
</script>
